import EntityMFADropdown from '../formFields/EntityMFADropdown';
import EntityVisibilityGroupDropdown from '../formFields/EntityVisibilityGroupDropdown';

const EntityAdminGeneral = ({ darkMode, errors }) => {
    return (
        <>
            <EntityMFADropdown darkMode={darkMode} errors={errors} />
            <EntityVisibilityGroupDropdown
                darkMode={darkMode}
                errors={errors}
            />
        </>
    );
};

export default EntityAdminGeneral;
